import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDashboard, faList } from "@fortawesome/free-solid-svg-icons";
function PdmcUsecaseSidebar() {
    return (
        <>
<div className="container">
<div className="pdmcsidebars">
<ul class="sidebar-nav fixed-bottom pdmcusecases" id="sidebar-nav">         
         <li class="nav-item"><NavLink className="nav-link collapsed" to="/pdmcanalyticA"><i><FontAwesomeIcon icon={faList}/> </i><span>Crop-Wise and State-Wise area Irrigated</span></NavLink></li>
         <li class="nav-item"><NavLink className="nav-link collapsed" to="/pdmcanalyticB"><i><FontAwesomeIcon icon={faList}/> </i><span>State-Wise, Crop-Wise and Irrigated-Type-Wise area Irrigated</span></NavLink></li>
         <li class="nav-item"><NavLink className="nav-link collapsed" to="/pdmcanalyticC"><i><FontAwesomeIcon icon={faList}/> </i><span> Type of Irrigation</span></NavLink></li>
         <li class="nav-item d-none"><NavLink className="nav-link collapsed" to="/schemereports"><i><FontAwesomeIcon icon={faDashboard}/> </i><span> All Schemes</span></NavLink></li>
        </ul>
</div>
</div>
        </>
              

 );
}           
export default PdmcUsecaseSidebar